/* Used only by the dining feature draft grid. */
const CDFShape = {
  version: 0,
  cache: new Map(),
  keys: ['round', 'rectangle', 'square', 'oval', 'other'],

  normalize(params) {
    const p = new URLSearchParams(params);
    p.delete('view');
    p.delete('preview_theme_id');

    if (p.has('cuumy_shape')) {
      p.delete('page');
    }

    return p.toString();
  },

  async feed(url) {
    const source = new URL(url, location.origin);
    const u = new URL('/collections/diningtable', location.origin);

    u.search = source.search;
    u.searchParams.set('section_id', 'cuumy-table-shape-feed');

    ['cuumy_shape', 'cuumy_shape_page', 'page'].forEach((key) => {
      u.searchParams.delete(key);
    });

    const key = u.toString();

    if (this.cache.has(key)) {
      return this.cache.get(key);
    }

    const get = async (page) => {
      const pageURL = new URL(u);
      pageURL.searchParams.set('page', page);

      const response = await fetch(pageURL, {
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error('Shape results unavailable');
      }

      const doc = new DOMParser().parseFromString(
        await response.text(),
        'text/html'
      );

      const feed = doc.querySelector('[data-cdf-feed]');

      if (!feed) {
        throw new Error('Shape results missing');
      }

      return feed;
    };

    const first = await get(1);
    const pages = Number(first.dataset.pages) || 1;
    const feeds = [first];

    for (let page = 2; page <= pages; page += 3) {
      feeds.push(
        ...await Promise.all(
          Array.from(
            {
              length: Math.min(3, pages - page + 1)
            },
            (_, index) => get(page + index)
          )
        )
      );
    }

    const unique = new Map();

    feeds.forEach((feed) => {
      feed.querySelectorAll('[data-cdf-product]').forEach((card) => {
        unique.set(card.dataset.cdfProduct, card);
      });
    });

    const cards = [...unique.values()];

    this.cache.set(key, cards);

    return cards;
  },

  async transform(html, url) {
    const params = new URL(url, location.origin).searchParams;

    const chosen = params
      .getAll('cuumy_shape')
      .filter((shape) => this.keys.includes(shape));

    const doc = new DOMParser().parseFromString(html, 'text/html');

    doc.querySelectorAll('[name="cuumy_shape"]').forEach((input) => {
      input.checked = chosen.includes(input.value);
    });

    doc.querySelectorAll('[name="cuumy_shape"]').forEach((input) => {
      input.toggleAttribute('checked', input.checked);
    });

    if (!chosen.length) {
      return doc.documentElement.outerHTML;
    }

    const cards = await this.feed(url);

    const counts = Object.fromEntries(
      this.keys.map((key) => [key, 0])
    );

    cards.forEach((card) => {
      if (card.dataset.cdfShape in counts) {
        counts[card.dataset.cdfShape]++;
      }
    });

    doc.querySelectorAll('[data-cdf-count]').forEach((element) => {
      element.textContent = counts[element.dataset.cdfCount];
    });

    const filtered = cards.filter((card) => {
      return chosen.includes(card.dataset.cdfShape);
    });

    const container = doc.getElementById('ProductGridContainer');
    const grid = doc.getElementById('product-grid');

    if (!container || !grid) {
      throw new Error('Grid missing');
    }

    const size = Number(container.dataset.cdfPageSize) || 24;
    const pages = Math.max(1, Math.ceil(filtered.length / size));

    const page = Math.min(
      pages,
      Math.max(
        1,
        Number(params.get('cuumy_shape_page')) || 1
      )
    );

    if (filtered.length) {
      grid.replaceChildren(
        ...filtered
          .slice((page - 1) * size, page * size)
          .map((card) => doc.importNode(card, true))
      );
    } else {
      grid.replaceChildren();

      const empty = doc.createElement('li');
      empty.className = 'columns';
      empty.style.gridColumn = '1 / -1';
      empty.textContent =
        '該当する商品がありません。形状や他の条件を変更してください。';

      grid.append(empty);
    }

    let pagination = doc.querySelector('[data-cdf-pagination]');

    if (!pagination) {
      pagination = doc.createElement('div');
      pagination.dataset.cdfPagination = '';
      grid.after(pagination);
    }

    pagination.replaceChildren();

    if (pages > 1) {
      const nav = doc.createElement('nav');

      nav.setAttribute('aria-label', 'ページ切り替え');
      nav.style.cssText =
        'display:flex;flex-wrap:wrap;justify-content:center;gap:16px;margin:30px 0';

      for (let index = 1; index <= pages; index++) {
        const link = doc.createElement('a');
        const target = new URL(url, location.origin);

        target.searchParams.delete('section_id');
        target.searchParams.set('cuumy_shape_page', index);
        target.hash = 'cdf-products';

        link.href = target.toString();
        link.dataset.cdfPage = '';
        link.textContent = index;

        if (index === page) {
          link.setAttribute('aria-current', 'page');
          link.style.fontWeight = '700';
        }

        nav.append(link);
      }

      pagination.append(nav);
    }

    doc.querySelectorAll('#ProductCount').forEach((element) => {
      element.textContent = filtered.length + ' 商品';
    });

    return doc.documentElement.outerHTML;
  },

  async render(html, url, event, version) {
    try {
      const output = await this.transform(html, url);

      if (version !== this.version) {
        return;
      }

      FacetFiltersForm.renderFilters(output, event);
      FacetFiltersForm.renderProductGridContainer(output);
      FacetFiltersForm.renderProductCount(output);
    } catch (error) {
      if (version !== this.version) {
        return;
      }

      document
        .querySelectorAll(
          '#ProductGridContainer .loading, ' +
          '.thb-filter-count.loading, ' +
          '.mobile-filter-count.loading'
        )
        .forEach((element) => {
          element.classList.remove('loading');
        });

      let status = document.getElementById('cdf-shape-error');

      if (!status) {
        status = document.createElement('p');
        status.id = 'cdf-shape-error';
        status.setAttribute('role', 'alert');

        const productGridContainer = document.getElementById(
          'ProductGridContainer'
        );

        if (productGridContainer) {
          productGridContainer.prepend(status);
        }
      }

      if (status) {
        status.textContent =
          '商品を読み込めませんでした。もう一度お試しください。';
      }
    }
  }
};

document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-cdf-page]');

  if (
    !link ||
    event.ctrlKey ||
    event.metaKey ||
    event.shiftKey ||
    event.altKey
  ) {
    return;
  }

  event.preventDefault();

  FacetFiltersForm.renderPage(
    new URL(link.href).searchParams.toString()
  );
});

document.addEventListener('DOMContentLoaded', () => {
  const mobileForm = document.getElementById(
    'FacetFiltersFormMobile'
  );

  const controller = document.querySelector(
    'facet-filters-form'
  );

  if (mobileForm && controller) {
    mobileForm.addEventListener(
      'input',
      debounce((event) => {
        controller.onSubmitHandler(event);
      }, 500)
    );
  }

  FacetFiltersForm.renderPage(
    location.search.slice(1),
    null,
    false
  );
});

class FacetsToggle extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.getElementById('Facet-Drawer');
  }

  connectedCallback() {
    this.addEventListener('click', () => {
      if (OverlayManager.isOpen(this.drawer)) {
        OverlayManager.close(this.drawer);
      } else {
        OverlayManager.open(this.drawer);
      }
    });
  }
}

customElements.define('facet-toggle', FacetsToggle);

class SidebarToggle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const span = this.querySelector('span');
    const hideFilters = span.textContent;

    this.addEventListener('click', (event) => {
      event.preventDefault();

      this.drawer = document.getElementById('Sidebar-Container');
      this.drawer.classList.toggle('facets--sidebar-open');

      span.textContent = this.drawer.classList.contains(
        'facets--sidebar-open'
      )
        ? hideFilters
        : theme.strings.showFilters;
    });
  }
}

customElements.define('sidebar-toggle', SidebarToggle);

class MoreFilters extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      const content = this.closest('.thb-filter-content');

      if (!content) {
        return;
      }

      const list = content.querySelector('ul');

      if (!list) {
        return;
      }

      if (list.hasAttribute('filters-open')) {
        this.textContent = theme.strings.showMore;
        list.removeAttribute('filters-open');
      } else {
        this.textContent = theme.strings.showLess;
        list.setAttribute('filters-open', '');
      }

      event.preventDefault();
    });
  }
}

customElements.define('more-filters', MoreFilters);

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick =
      this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const form = this.querySelector('form');

    if (form) {
      form.addEventListener(
        'input',
        this.debouncedOnSubmit.bind(this)
      );
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;

      if (
        searchParams === FacetFiltersForm.searchParamsPrev
      ) {
        return;
      }

      FacetFiltersForm.renderPage(
        searchParams,
        null,
        false
      );
    };

    window.addEventListener(
      'popstate',
      onHistoryChange
    );
  }

  static toggleActiveFacets(disable = true) {
    document
      .querySelectorAll('.js-facet-remove')
      .forEach((element) => {
        element.classList.toggle(
          'disabled',
          disable
        );
      });
  }

  static renderPage(
    searchParams,
    event,
    updateURLHash = true
  ) {
    const productGridContainer =
      document.getElementById(
        'ProductGridContainer'
      );

    const productGrid =
      document.getElementById('product-grid');

    if (!productGridContainer || !productGrid) {
      return;
    }

    searchParams = CDFShape.normalize(searchParams);

    CDFShape.version++;

    FacetFiltersForm.searchParamsPrev =
      searchParams;

    const sections =
      FacetFiltersForm.getSections();

    const countContainers =
      document.querySelectorAll(
        '.thb-filter-count, .mobile-filter-count'
      );

    const collection =
      productGridContainer.querySelector(
        '.collection'
      );

    if (collection) {
      collection.classList.add('loading');
    }

    countContainers.forEach((container) => {
      container.classList.add('loading');
    });

    sections.forEach(() => {
      const url =
        `/collections/diningtable` +
        `?section_id=cuumy-table-product-grid` +
        `&${searchParams}`;

      const filterDataUrl = (element) => {
        return element.url === url;
      };

      if (
        FacetFiltersForm.filterData.some(
          filterDataUrl
        )
      ) {
        FacetFiltersForm.renderSectionFromCache(
          filterDataUrl,
          event
        );
      } else {
        FacetFiltersForm.renderSectionFromFetch(
          url,
          event
        );
      }
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(
        searchParams
      );
    }
  }

  static renderSectionFromFetch(url, event) {
    const version = CDFShape.version;

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            'Collection unavailable'
          );
        }

        return response.text();
      })
      .then((html) => {
        FacetFiltersForm.filterData.push({
          html,
          url
        });

        return CDFShape.render(
          html,
          url,
          event,
          version
        );
      })
      .catch(() => {
        CDFShape.render(
          '',
          url,
          event,
          version
        );
      });
  }

  static renderSectionFromCache(
    filterDataUrl,
    event
  ) {
    const cached =
      FacetFiltersForm.filterData.find(
        filterDataUrl
      );

    if (!cached) {
      return;
    }

    CDFShape.render(
      cached.html,
      cached.url,
      event,
      CDFShape.version
    );
  }

  static renderProductGridContainer(html) {
    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const sourceContainer =
      parsedHTML.getElementById(
        'ProductGridContainer'
      );

    const targetContainer =
      document.getElementById(
        'ProductGridContainer'
      );

    if (!sourceContainer || !targetContainer) {
      return;
    }

    targetContainer.innerHTML =
      sourceContainer.innerHTML;

    const headerHeight = parseInt(
      getComputedStyle(
        document.documentElement
      ).getPropertyValue('--header-height'),
      10
    ) || 0;

    const top =
      targetContainer.getBoundingClientRect().top +
      document.documentElement.scrollTop -
      headerHeight -
      30;

    targetContainer
      .querySelectorAll('.lazyload')
      .forEach((image) => {
        if (
          window.lazySizes &&
          lazySizes.loader
        ) {
          lazySizes.loader.unveil(image);
        }
      });

    window.scrollTo({
      top,
      left: 0,
      behavior: 'smooth'
    });

    document
      .getElementById('header')
      ?.querySelector('.full-menu')
      ?.setMenuHeight();
  }

  static renderProductCount(html) {
    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const countHTML =
      parsedHTML.getElementById(
        'ProductCount'
      );

    const containers =
      document.getElementsByClassName(
        'thb-filter-count'
      );

    if (!countHTML) {
      return;
    }

    for (const container of containers) {
      container.innerHTML =
        countHTML.innerHTML;

      container.classList.remove(
        'loading'
      );
    }
  }

  static renderFilters(html) {
    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    [
      '#FacetFiltersForm',
      '#FacetFiltersFormMobile'
    ].forEach((selector) => {
      const sourceForm =
        parsedHTML.querySelector(selector);

      const targetForm =
        document.querySelector(selector);

      if (sourceForm && targetForm) {
        targetForm.innerHTML =
          sourceForm.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(
      parsedHTML
    );

    FacetFiltersForm.renderAdditionalElements(
      parsedHTML
    );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.active-facets'
    ];

    activeFacetElementSelectors.forEach(
      (selector) => {
        const activeFacetsElement =
          html.querySelector(selector);

        const currentElement =
          document.querySelector(selector);

        if (
          !activeFacetsElement ||
          !currentElement
        ) {
          return;
        }

        currentElement.innerHTML =
          activeFacetsElement.innerHTML;
      }
    );

    FacetFiltersForm.toggleActiveFacets(
      false
    );
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-filter-count'
    ];

    mobileElementSelectors.forEach(
      (selector) => {
        const source =
          html.querySelector(selector);

        const target =
          document.querySelector(selector);

        if (!source || !target) {
          return;
        }

        target.innerHTML =
          source.innerHTML;

        target.classList.remove(
          'loading'
        );
      }
    );
  }

  static updateURLHash(searchParams) {
    history.pushState(
      {
        searchParams
      },
      '',
      `${window.location.pathname}${
        searchParams
          ? '?'.concat(searchParams)
          : ''
      }`
    );
  }

  static getSections() {
    const productGrid =
      document.getElementById(
        'product-grid'
      );

    if (!productGrid) {
      return [];
    }

    return [
      {
        section:
          productGrid.dataset.id
      }
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sourceForm =
      event.target.closest('form');

    if (!sourceForm) {
      return;
    }

    const formData =
      new FormData(sourceForm);

    if (
      !sourceForm.querySelector(
        '[name="cuumy_shape"]'
      )
    ) {
      new URLSearchParams(
        location.search
      )
        .getAll('cuumy_shape')
        .forEach((value) => {
          formData.append(
            'cuumy_shape',
            value
          );
        });
    }

    const searchParams =
      new URLSearchParams(formData);

    if (
      searchParams.get(
        'filter.v.price.gte'
      ) === '0.00'
    ) {
      searchParams.delete(
        'filter.v.price.gte'
      );
    }

    const priceSlider =
      document.querySelector(
        '.price_slider'
      );

    if (priceSlider) {
      const maximum = parseFloat(
        priceSlider.dataset.max
      ).toFixed(2);

      if (
        searchParams.get(
          'filter.v.price.lte'
        ) === maximum
      ) {
        searchParams.delete(
          'filter.v.price.lte'
        );
      }
    }

    FacetFiltersForm.renderPage(
      searchParams.toString(),
      event
    );
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    FacetFiltersForm.toggleActiveFacets();

    const currentURL =
      event.currentTarget.href;

    const queryPosition =
      currentURL.indexOf('?');

    const query =
      queryPosition === -1
        ? ''
        : currentURL.slice(
            queryPosition + 1
          );

    const retained =
      new URLSearchParams(query);

    if (retained.toString()) {
      new URLSearchParams(
        location.search
      )
        .getAll('cuumy_shape')
        .forEach((value) => {
          retained.append(
            'cuumy_shape',
            value
          );
        });
    }

    FacetFiltersForm.renderPage(
      retained.toString()
    );
  }
}

FacetFiltersForm.filterData = [];

FacetFiltersForm.searchParamsInitial =
  window.location.search.slice(1);

FacetFiltersForm.searchParamsPrev =
  window.location.search.slice(1);

customElements.define(
  'facet-filters-form',
  FacetFiltersForm
);

FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('a').forEach(
      (item) => {
        item.addEventListener(
          'click',
          (event) => {
            event.preventDefault();

            const form =
              this.closest(
                'facet-filters-form'
              ) ||
              document.querySelector(
                'facet-filters-form'
              );

            if (form) {
              form.onActiveFilterClick(
                event
              );
            }
          }
        );
      }
    );
  }
}

customElements.define(
  'facet-remove',
  FacetRemove
);

class FacetToolbar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.productGrid =
      this.closest(
        '#ProductGridContainer'
      );

    this.compareToggle =
      this.querySelector(
        '#compare_toggle'
      );

    this.layoutSwitcher =
      this.querySelector(
        '.facets--bar-view-as'
      );

    this.buttons =
      this.querySelectorAll(
        '.facets--bar-view-as-button'
      );

    this.productLayout =
      window.localStorage.getItem(
        'product-layout'
      );

    if (this.layoutSwitcher) {
      this.buttons.forEach((button) => {
        button.addEventListener(
          'click',
          (event) => {
            this.buttons.forEach(
              (item) => {
                item.removeAttribute(
                  'disabled'
                );
              }
            );

            this.onLayoutChange(
              button,
              button.dataset.value
            );

            event.preventDefault();
          }
        );
      });

      if (
        this.productLayout === 'list'
      ) {
        const toggle =
          this.querySelector(
            `.facets--bar-view-as-button-${this.productLayout}`
          );

        if (toggle) {
          toggle.click();
        }
      }
    }

    if (this.compareToggle) {
      this.compareToggle.addEventListener(
        'change',
        this.onCompare
      );
    }
  }

  onLayoutChange(button, value) {
    button.setAttribute('disabled', '');

    if (this.productGrid) {
      this.productGrid.dataset.layout =
        value;
    }

    window.localStorage.setItem(
      'product-layout',
      value
    );
  }

  onCompare(event) {
    document.body.classList.toggle(
      'compare-true'
    );

    event.preventDefault();
  }
}

customElements.define(
  'facet-toolbar',
  FacetToolbar
);

class PriceSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slider =
      this.querySelector(
        '.price_slider'
      );

    this.amounts =
      this.querySelector(
        '.price_slider_amount'
      );

    this.form =
      this.closest(
        'facet-filters-form'
      ) ||
      document.querySelector(
        'facet-filters-form'
      );

    if (
      !this.slider ||
      !this.amounts ||
      !this.form ||
      !window.noUiSlider
    ) {
      return;
    }

    this.inputEvent =
      new CustomEvent('input');

    const args = {
      start: [
        parseFloat(
          this.slider.dataset
            .minValue || 0
        ),
        parseFloat(
          this.slider.dataset
            .maxValue ||
          this.slider.dataset.max
        )
      ],
      connect: true,
      step: 10,
      direction: document.dir,
      handleAttributes: [
        {
          'aria-label': 'lower'
        },
        {
          'aria-label': 'upper'
        }
      ],
      range: {
        min: 0,
        max: parseFloat(
          this.slider.dataset.max
        )
      }
    };

    noUiSlider.create(
      this.slider,
      args
    );

    this.slider.noUiSlider.on(
      'update',
      this.onSliderUpdate.bind(this)
    );

    this.slider.noUiSlider.on(
      'change',
      this.onSliderChange.bind(this)
    );
  }

  onSliderUpdate(values) {
    const minimumInput =
      this.amounts.querySelector(
        '.field__input_min'
      );

    const maximumInput =
      this.amounts.querySelector(
        '.field__input_max'
      );

    if (minimumInput) {
      minimumInput.value = values[0];
    }

    if (maximumInput) {
      maximumInput.value = values[1];
    }
  }

  onSliderChange() {
    const form =
      this.form.querySelector('form');

    if (form) {
      form.dispatchEvent(
        this.inputEvent
      );
    }
  }
}

customElements.define(
  'price-slider',
  PriceSlider
);